import { ReactElement, useMemo, useState } from 'react'
import { I18n } from 'src/i18n'
import styled from 'styled-components'
import { ValidationTag as ValidationTagEnum } from '../Common/interfaces'
import { getTagInfo } from './helper'
import { defaultTheme } from 'src/theme'
import { Tooltip } from 'src/ui-components'

interface Props {
  type: ValidationTagEnum
}

const textStyle = {
  paddingLeft: '0.3rem',
  color: defaultTheme.colors.almostBlack,
}

const ValidationTag = (props: Props): ReactElement => {
  const { type } = props
  const [showTooltip, setShowTooltip] = useState(false)

  const info = useMemo(() => getTagInfo(type), [type])

  return (
    <Wrapper>
      <Tooltip
        show={info.shortDescription && showTooltip}
        message={info.shortDescription}
        onClose={() => setShowTooltip(false)}
      >
        <Tag
          style={{ ...info }}
          onMouseOver={() => setShowTooltip(true)}
          onMouseLeave={() => setShowTooltip(false)}
        >
          {info.icon}
          <I18n style={textStyle} name={info.label} />
        </Tag>
      </Tooltip>
    </Wrapper>
  )
}

const Tag = styled.div`
  width: fit-content;
  min-height: 24px;
  padding: 0.3rem 0.5rem 0.3rem 0.5rem;
  border-radius: 4px 4px 4px 4px;
  margin: 0.5rem 0rem 0.5rem 0rem;
`

const Wrapper = styled.div`
  height: fit-content;
  width: fit-content;
`

export default ValidationTag
